import { ValidationType } from 'utils/ValidationUtils';

export enum EtapaProjeto {
  infosIniciais = 'infos-iniciais',
  curriculo = 'curriculo',
  expedicao = 'expedicao',
  tituloDoProjeto = 'titulo',
  indices = 'indices',
  mobilizacao = 'mobilizacao',
  aprendizagem = 'aprendizagem',
  indiceFinal = 'indice-final',
  revisao = 'revisao',
}

// Enum somente para melhorar a escrita
export enum EtapasEnsinoInfantil {
  Bercario = 14,
  Maternal = 15,
  PreEscola = 16,
}

export enum CategoriasProjetos {
  nomeDoProjeto = 0,
  professor = 1,
  assessorPedagogico = 2,
  instituicao = 3,
}

export const indexOfEtapa = (etapa: EtapaProjeto) =>
  Object.values(EtapaProjeto).indexOf(etapa);

export const getEtapaProjetoByIndex = (n: number) => {
  return Object.values(EtapaProjeto)[n];
};

export enum PrincipioValor {
  Cooperacao = 1,
  Cidadania = 2,
  Solidariedade = 3,
  Empreendedorismo = 4,
  RespeitoDiversidade = 5,
  Justica = 6,
  Dialogo = 7,
}

export type DocumentoProjeto = {
  caminho?: string;
  caminhoCompressed?: string;
  cooperativa: string;
  etapa: number;
  file?: File | null;
  id?: number;
  idProjeto?: number;
  percent?: number;
  principal: boolean;
  status: number;
  tipo: string; 
};
export interface ProjetoType {
  id: number;
  nome: string;
  dataCadastro: string;
  dataAlteracao: string;
  justificativa: string;
  cienciaCordenador: boolean;
  consultaPublica: boolean;
  status: unknown;
  descricaoPerguntaExploratoria?: string | null;
  descricaoTerritorioInvestigado?: string | null;
  descricaoObjetivoExpedicao?: string | null;
  descricaoExpedicao?: string | null;
  descricaoPerguntas?: string | null;
  descricaoIndiceInicial?: string | null;
  descricaoIndiceFormativo?: string | null;
  descricaoComponenteCurricular?: string | null;
  descricaoAtividadeDesenvolvida?: string | null;
  descricaoPrincipioValor?: string | null;
  descricaoComunidadeAprendizagem?: string | null;
  descricaoAtividadeIntegradora?: string | null;
  descricaoIndiceFinal?: string | null;
  descricaoMostraPedagogica?: string | null;
  flgNovoTemplate: boolean;
  flgInfantil: boolean;
  descricaoMarcouEducador?: string | null;
  apoiadores: string | null;
  idUsuario: string;
  codigoCooperativa: string | null;
  idEscola: number | null;
  quantidadeAlunosTurma: number;
  descricaoTurma: string;
  cpfsProfessores: string[];
  cpfsAssessores: string[];
  idEtapasEnsino: number[];
  idPrincipiosValores: PrincipioValor[];
  avaliacoes: RevisaoDTO[];
  documentos: DocumentoProjeto[];
  direitoImagem: boolean;
  periodoInicial?: string;
  periodoFinal?: string;
  checkCoordenador: boolean;
  checkProfGestor: boolean;
  modalidades: number[];
}

export interface EtapaEducacaoDTO {
  id: number;
  nome: string;
}

export interface PrincipioValorDTO {
  id: number;
  nome: string;
}

export interface ModalidadeDTO {
  idModalidade: number;
  nome: string;
}

export enum StatusEtapa {
  Disabled = 99, // Cinza
  SemPreenchimento = 0, // Amarelo
  AguardandoAprovacao = 1, // Aguardando Aprovação
  Aprovada = 2, // Verde
  PontoDeAtencao = 3, // Recusada
}

export enum SituacoesEnum {
  PENDENTE = 0,
  APROVADO_ATIVADO = 1,
  REJEITADO = 2,
  INATIVADO = 3,
}

export const SituacoesDescricao = {
  [SituacoesEnum.APROVADO_ATIVADO]: 'Aprovado/Ativado',
  [SituacoesEnum.INATIVADO]: 'Inativado',
  [SituacoesEnum.PENDENTE]: 'Pendente',
  [SituacoesEnum.REJEITADO]: 'Rejeitado',
};

export interface RevisaoDTO {
  cpfAssessor?: string;
  nomeAssessor?: string;
  dataCadastro?: string;
  etapa: number;
  status: StatusEtapa;
  comentario?: string;
}
export interface StatusEtapaResponseDTO {
  status: StatusEtapa;
  historico: RevisaoDTO[];
}

export type ValidationFieldType = {
  required?: boolean;
  validation?: (
    value?: string | number | string[] | number[],
    projeto?: Partial<ProjetoType>
  ) => ValidationType;
};
